
import { BasicButton } from "@goodgamestudios/asset-globals";

import { EnvGlobalsHandler, IEnvironmentGlobals } from "@goodgamestudios/core";
import { BasicDialogHandler } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { TextFormat } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Constants } from "../../constants/Poker2Constants";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2ChatEvent } from "../../event/Poker2ChatEvent";
import { Poker2SliderEvent } from "../../event/Poker2SliderEvent";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { SeatVO } from "../../gamevo/SeatVO";
import { Poker2Model } from "../../model/Poker2Model";
import { SliderHelper } from "./SliderHelper";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class TableChatHelper {
    public static ADMIN_MSG: number = -100;
    public static PLAYER_MSG: number = 1;
    public static SPEC_MSG: number = 2;
    public static MOD_MSG: number = 3;

    private chatslider: SliderHelper;
    private chatHeight: number = 0;
    private chatcomponent: MovieClip;
    private selectedButton: BasicButton;
    private muteSpecsChat: boolean = false;

    constructor(component: MovieClip) {
        this.chatcomponent = component;

        // apply mask via code to fix a text view problem in flashplayer 11
        this.chatcomponent.mc_textholder.mask = this.chatcomponent.mc_mask;

        // init scrollbar (using slider as a scrollbar)
        this.chatslider = new SliderHelper(this.chatcomponent.mc_chatslider);
        this.chatslider.StepSize = 5;

        // init listeners
        this.chatcomponent.btn_chatenter.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onChatEnterClick));
        this.chatcomponent.btn_chatmute.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onChatMuteClick));
        this.chatcomponent.mc_chatslider.addEventListener("onSliding", this.bindFunction(this.onChatSliding));
        this.chatcomponent.mc_chatslider.addEventListener("slideUp", this.bindFunction(this.onChatSliding));
        this.chatcomponent.mc_chatslider.addEventListener("slideDown", this.bindFunction(this.onChatSliding));

        // shift dialog window a bit
        this.chatcomponent._1.x = -16;
    }

    private onChatEnterClick(event: MouseEvent): void {
        if (this.tutorialController.isActive)
            return;

        if (event.currentTarget == this.chatcomponent.btn_chatenter) {
            BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);
            this.onSendMsg();
        }
    }

    private onChatMuteClick(event: MouseEvent): void {
        if (this.tutorialController.isActive)
            return;

        if (event.target == this.chatcomponent.btn_chatmute) {
            this.activateButton(this.chatcomponent.btn_chatmute);
        }
    }

    private activateButton(button: BasicButton): void {
        if (this.selectedButton != button) {
            this.selectedButton = button;
            this.selectedButton.selected();
            this.muteSpecsChat = true;
            this.chatcomponent.btn_chatmute.toolTipText = Poker2Model.languageData.getTextById("table_chat_showSpecsTT_muteOn");
        }
        else {
            this.selectedButton.deselected();
            this.selectedButton = null;
            this.muteSpecsChat = false;
            this.chatcomponent.btn_chatmute.toolTipText = Poker2Model.languageData.getTextById("table_chat_showSpecsTT_muteOff");
        }
    }

    public setFocusToChatInputField(): void {
        this.chatcomponent.stage.focus = this.chatcomponent.txt_chatmsg;
    }

    public onSendMsg(): void {
        if (this.chatcomponent.txt_chatmsg.text == "/clientversion") {
            this.writeNewMsg(Poker2Model.userData.userID, Poker2Model.userData.playerID, "Version", 0x000000, this.env.versionText);
            this.chatcomponent.txt_chatmsg.text = "";
            return;
        }

        this.testWindows();

        if (Poker2Model.userData.userLevel < 1 || Poker2Model.userData.isGuest())
            this.writeNewMsg(-1, -1, Poker2Model.languageData.getTextById("table_chat_bot"), 0x000000, Poker2Model.languageData.getTextById("generic_chat_writeable"));
        else {
            var chatMsg: string = TextValide.getValideSmartFoxJSONTextMessage(this.chatcomponent.txt_chatmsg.text);

            if (chatMsg.length > 0) {
                if (this.tutorialController.isActive)
                    return;

                BasicModel.smartfoxClient.sendMessage("tch", [JSON.stringify({ text: chatMsg })]);
            }
        }
        this.chatcomponent.txt_chatmsg.text = "";
    }

    private scrollToEnd(): void {
        if (this.extraChatHeight > this.chatcomponent.mc_mask.height) {
            this.chatcomponent.mc_textholder.y = this.chatcomponent.mc_mask.y - (this.extraChatHeight - this.chatcomponent.mc_mask.height);
            this.enableButtons(true);
        }
        this.chatslider.initSlider(0, 1, 1);
        //			updateSlider();
    }

    private onChatSliding(event: Poker2SliderEvent): void {
        if (this.extraChatHeight <= this.chatcomponent.mc_mask.height)
            return;
        this.chatcomponent.mc_textholder.y = this.chatcomponent.mc_mask.y - (this.extraChatHeight - this.chatcomponent.mc_mask.height) * event.percentValue / 100;
    }

    private updateSlider(): void {
        if (this.extraChatHeight < this.chatcomponent.mc_mask.height)
            return;

        var textholderY: number = int((this.chatcomponent.mc_textholder.y - this.chatcomponent.mc_mask.y));
        var height: number = int(-(this.extraChatHeight - this.chatcomponent.mc_mask.height));
        var percentY: number = 100 - ((height - textholderY) / height * 100);

        this.chatcomponent.mc_chatslider.btn_slider.y = this.chatcomponent.mc_chatslider.mc_sliderbar.y + (this.chatcomponent.mc_chatslider.mc_sliderbar.height * percentY / 100);
    }

    public onAddMsg(event: Poker2ChatEvent): void {
        event.msg = event.msg.replace(/&#145;/g, "'");
        if (event.playerId == TableChatHelper.ADMIN_MSG) {
            this.writeNewMsg(TableChatHelper.ADMIN_MSG, TableChatHelper.ADMIN_MSG, Poker2Model.languageData.getTextById("generic_admin"), 0x000000, event.msg);
            return;
        }

        if (event.isMod) {
            this.writeNewMsg(3, event.playerId, Poker2Model.languageData.getTextById("generic_moderator"), 0x000000, event.msg);
            return;
        }

        if (!Poker2Model.sessionData.isOnIgnorList(event.playerId)) {
            if (event.spec == true && this.muteSpecsChat == false) {
                // Nachricht vom Gast
                this.writeNewMsg(2, event.playerId, event.name, int(0x000000), event.msg);
            }
            else if (event.spec == false || event.playerId == Poker2Model.userData.playerID) {
                // Nachricht vom Spieler am Tisch
                var currentTable: LobbyTablesVO = Poker2Model.onTableData.currentTable;
                var index: number = int(Poker2Model.onTableData.getSeatIndexByPlayerId(event.playerId));
                var seatVO: SeatVO = currentTable.seats[index] as SeatVO;

                if (seatVO.playerId >= 0) {
                    this.writeNewMsg(1, event.playerId, event.name, int(Poker2Constants.SEAT_COLOR[index]), event.msg);
                }
            }
        }
    }

    private writeNewMsg(userId: number, playerId: number, playerName: string, color: number, msg: string): void {
        var namefield: Library.PokerTableActionPanel.ChatNameText = new Library.PokerTableActionPanel.ChatNameText();
        var msgfield: Library.PokerTableActionPanel.ChatMsgText = new Library.PokerTableActionPanel.ChatMsgText();

        if (Poker2LanguageFontManager.getInstance().useDefaultFont) {
            Poker2LanguageFontManager.getInstance().changeFontByLanguage(namefield.txt_msg);
            Poker2LanguageFontManager.getInstance().changeFontByLanguage(msgfield.txt_msg);
        }
        else {
            namefield.txt_msg.embedFonts = false;
            msgfield.txt_msg.embedFonts = false;
        }
        namefield.txt_msg.text = playerName + ": ";
        namefield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        namefield.txt_msg.width = namefield.txt_msg.textWidth + 5;
        namefield.txt_msg.height = namefield.txt_msg.textHeight + 5;
        namefield.txt_msg.textColor = color;
        namefield.txt_msg.mouseEnabled = true;

        if (playerId > 0 && playerId != Poker2Model.userData.playerID) {
            namefield.mouseChildren = false;
            namefield.playerId = playerId;
            namefield.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickNameField));
            namefield.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutNameField));
            namefield.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverNameField));
        }

        msgfield.mouseEnabled = false;
        msgfield.mouseChildren = false;
        msgfield.x = namefield.txt_msg.width;
        var format: TextFormat = msgfield.txt_msg.defaultTextFormat;

        msgfield.txt_msg.defaultTextFormat = format;
        msgfield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        msgfield.txt_msg.text = TextValide.parseChatJSONMessage(msg);
        msgfield.txt_msg.width = this.chatcomponent.mc_mask.width - namefield.txt_msg.width - 1;
        msgfield.txt_msg.height = msgfield.txt_msg.textHeight + 5;

        msgfield.y = namefield.y = this.chatHeight;
        msgfield.y += 1;

        this.chatcomponent.mc_textholder.addChild(msgfield);
        this.chatcomponent.mc_textholder.addChild(namefield);

        //chatHeight = chatkomponent.mc_textholder.height;
        this.chatHeight += int(msgfield.height - 4);

        this.scrollToEnd();
    }

    private get extraChatHeight(): number {
        return this.chatHeight + 5;
    }

    private onClickNameField(event: MouseEvent): void {
        if (this.tutorialController.isActive)
            return;

        var namefield: Library.PokerTableActionPanel.ChatNameText = event.target as Library.PokerTableActionPanel.ChatNameText;
        var paramObject: any = { id: namefield.playerId, viewId: 1 };
        BasicModel.smartfoxClient.sendMessage("gpv", [JSON.stringify(paramObject)]);
    }

    private onMouseOutNameField(event: MouseEvent): void {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }

    private onMouseOverNameField(event: MouseEvent): void {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    public init(): void {
        if (Poker2Model.userData.gamePropertiesVO.isSpec == 0) {
            this.selectedButton = this.chatcomponent.btn_chatmute;
        }
        else {
            this.selectedButton = null;
        }
        this.activateButton(this.chatcomponent.btn_chatmute);
        this.enableButtons(false);
        this.chatHeight = 0;
        this.chatcomponent.txt_chatmsg.text = "";

        while (this.chatcomponent.mc_textholder.numChildren > 0) {
            var child: DisplayObject = this.chatcomponent.mc_textholder.getChildAt(0);

            if (instanceOfClass(child, "ChatNameText")) {
                child.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickNameField));
                child.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutNameField));
                child.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverNameField));
            }
            this.chatcomponent.mc_textholder.removeChildAt(0);
        }
        this.chatcomponent.mc_textholder.y = this.chatcomponent.mc_mask.y;
    }

    private enableButtons(able: boolean): void {
        this.chatcomponent.mc_chatslider.btn_slider.enableButton = able;
        this.chatcomponent.mc_chatslider.btn_up.enableButton = able;
        this.chatcomponent.mc_chatslider.btn_down.enableButton = able;
    }

    public destory(): void {
        this.chatcomponent.btn_chatmute.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onChatMuteClick));
        this.chatcomponent.btn_chatenter.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onChatEnterClick));
        this.chatcomponent.mc_chatslider.removeEventListener("onSliding", this.bindFunction(this.onChatSliding));
        this.chatcomponent.mc_chatslider.removeEventListener("slideUp", this.bindFunction(this.onChatSliding));
        this.chatcomponent.mc_chatslider.removeEventListener("slideDown", this.bindFunction(this.onChatSliding));

        if (this.chatslider)
            this.chatslider.destroy();
        this.chatslider = null;
    }

    public updateTextField(): void {
        if (!Poker2LanguageFontManager.getInstance().useDefaultFont) {
            while (this.chatcomponent.mc_textholder.numChildren > 0) {
                var child: MovieClip = this.chatcomponent.mc_textholder.getChildAt(0);

                if (child && "txt_msg" in child) {
                    child.txt_msg.embedFonts = false;
                }
            }
        }
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    //
    //
    //

    /**
     * for test only
     */
    private testWindows(): void {
        var chatMsg: string = TextValide.getValideSmartFoxJSONTextMessage(this.chatcomponent.txt_chatmsg.text);
        if (!chatMsg)
            return;

        if (EnvGlobalsHandler.globals.isLocal || EnvGlobalsHandler.globals.isTest) {
            var obj: any = {};
            if (chatMsg.indexOf('/set xp ') > -1) {
                // test show: Poker2LevelUpAnimDialog
                obj.chips = Poker2Model.userData.userCash;
                obj.gold = Poker2Model.userData.userGold;
                BasicController.commandDict.get("lvu").executeCommand(0, [0, JSON.stringify(obj)]);
            }

            if (chatMsg.indexOf('/test ') > -1) {
                if (chatMsg.indexOf('/test MailVeriDialog') > -1) {
                    BasicDialogHandler.getInstance().registerDialogs("Poker2MailVerificationDialog", null, true, BasicDialogHandler.PRIORITY_TOP);
                }
                if (chatMsg.indexOf('/test MailVerificationGift') > -1) {
                    obj.email = 'xxx@xxx.xx';
                    BasicController.commandDict.get("emv").executeCommand(0, [0, JSON.stringify(obj)]);
                }
                if (chatMsg.indexOf('/test MailConfirmGift') > -1) {
                    BasicController.commandDict.get("emc").executeCommand(0, []);
                }
                if (chatMsg.indexOf('/test TurnNextRound ') > -1) {
                    obj.round = parseInt(chatMsg.substr('/test turnNextRound '.length)); // 1,2,3
                    BasicController.commandDict.get("jte").executeCommand(0, [0, JSON.stringify(obj)]);
                }

                //					if (chatMsg.indexOf('/test buy')>-1)
                //					{
                //						obj.L = [[16001,45004]]; // z.b. jewleryTop_23003
                //						BasicController.commandDict["sbu"].executeCommand(0, [0,JSON.stringify(obj)]);
                //					}

                if (chatMsg.indexOf('/test achi') > -1) {
                    obj.id = 40001;
                    obj.rank = 3;
                    obj.ap = 111;
                    obj.xp = 222;
                    BasicController.commandDict.get("are").executeCommand(0, [0, JSON.stringify(obj)]);
                }
                if (chatMsg.indexOf('/test turnwin ') > -1) {
                    obj.name = 'TURNWIN';
                    obj.rank = parseInt(chatMsg.substr('/test turnwin '.length));
                    obj.chips = obj.rank > 2 ? 0 : 111;
                    obj.gold = 222;
                    obj.tp = 333; // tournamentPoints
                    obj.itemid = 400404; // jewleryTop_23003
                    BasicController.commandDict.get("jen").executeCommand(0, [0, JSON.stringify(obj)]);
                }
                if (chatMsg.indexOf('/test sitngo ') > -1) {
                    obj.name = 'TEST_SITNGO';
                    obj.rank = parseInt(chatMsg.substr('/test sitngo '.length));
                    obj.chips = 111;
                    obj.gold = 222;
                    obj.tp = 333;
                    BasicController.commandDict.get("sen").executeCommand(0, [0, JSON.stringify(obj)]);
                }
            }
        }
    }
}
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2LanguageFontManager } from "../Poker2LanguageFontManager";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
